<template>
    <main>
        <b-card title="Αναζήτηση">
            <b-form v-on:submit.prevent="noop">
                <b-form-row>
                    <b-form-checkbox v-model="isAdvanced" name="check-button" switch>
                        Σύνθετη
                    </b-form-checkbox>
                </b-form-row>
                <br>
                <b-form-row v-if="!isAdvanced">
                    <b-input-group>
                        <b-form-input type="text" placeholder="ΑΣΜ" v-model="searchedEfsa"
                                      :state="efsaValidation"></b-form-input>
                        <b-button variant="outline-primary" v-on:click="fetchData"
                                  v-bind:disabled="!efsaValidation">ΑΝΑΖΗΤΗΣΗ
                        </b-button>
                        <b-form-invalid-feedback :state="efsaValidation">
                            Ο Αριθμός Στρατιωτικού Μητρώου (ΑΣΜ) πρέπει να αποτελείται 11 ψηφία
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-row>
                <div v-else>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="job" label="Επάγγελμα">
                                <b-form-select id="job"
                                               v-model="searchedJobId"
                                               :options="jobOptions"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label-for="education" label="Εκπαίδευση">
                                <b-form-select id="education"
                                               v-model="searchedEducationId"
                                               :options="educationOptions"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="me" label="ΜΕ">
                                <b-form-select id="me"
                                               v-model="searchedMeeId"
                                               :options="meeOptions"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label-for="name" label="Όνομα">
                                <b-form-input id="name" v-model="searchedFirstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group label-for="last_name" label="Επίθετο">
                                <b-form-input id="last_name" v-model="searchedLastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label-for="birthday_from" label="Χρονολογία γέννησης από"
                                          description="YYYY">
                                <b-form-input
                                    id="birthday_from"
                                    v-model="searchedBirthdayFrom"
                                    :state="dateValidation(searchedBirthdayFrom)"
                                    type="text"
                                    placeholder="YYYY"
                                    autocomplete="off"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label-for="birthday_to" label="Χρονολογία γέννησης εώς"
                                          description="YYYY">
                                <b-form-input
                                    id="birthday_to"
                                    v-model="searchedBirthdayTo"
                                    :state="dateValidation(searchedBirthdayTo) && birthdayValidation"
                                    type="text"
                                    placeholder="YYYY"
                                    autocomplete="off"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="2">
                            <b-form-group label-for="all" label="Όλοι">
                                <b-form-checkbox id="all" v-model="searchedAll"></b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" v-if="!searchedAll">
                            <b-form-group label-for="registered" label="Εγγεγραμμένος">
                                <b-form-checkbox id="registered" v-model="searchedRegistered"></b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" v-if="searchedRegistered">
                            <b-form-group label-for="verified" label="Επιβεβαιωμένος">
                                <b-form-checkbox id="verified" v-model="searchedVerified"></b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <br>
                    <b-row class="justify-content-center">
                        <b-col md="2">
                            <b-button variant="outline-primary" v-on:click="reset">
                                ΕΠΑΝΑΦΟΡΑ
                            </b-button>
                        </b-col>
                        <b-col md="2">
                            <b-button :disabled="!advancedSearchValidation" variant="primary" v-on:click="fetchData">
                                ΑΝΑΖΗΤΗΣΗ
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-form>
        </b-card>
        <br>
        <span style="color: #7f7f7f">Σύνολο: {{ totalItems }}</span>
        <b-row class="justify-content-end">
            <b-button variant="success" size="sm" v-on:click="exportChanges">
                <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                Κατέβασμα σε excel
            </b-button>
        </b-row>
        <b-row class="overflow-auto">
            <b-table class="efedros-table" show-empty empty-text="Δεν υπάρχουν εγγραφές" :items="users"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="0">
                <template v-slot:cell(edit)="data">
                    <b-button size="sm" variant="outline-primary" @click="edit(data.item.efSa)">
                        <b-icon icon="pencil-square"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <b-pagination size="md" :total-rows="totalItems" @change="pageChange" v-model="currentPage"
                          :per-page="perPage"></b-pagination>
        </b-row>
        <div>
            <b-modal id="modal-1" title="Στοιχεία Εφέδρου" size="xl" v-if="selectedEfedros !== null">
                <user-details-form :selected-efedros="selectedEfedros"
                                   :is-disabled="isDisabled"
                                   @update:success="success"
                                   @update:error="error"
                                   ref="form"
                />
                <template #modal-footer>
                    <div class="w-100">
                        <b-button
                            variant="secondary"
                            size="sm"
                            @click="$bvModal.hide('modal-1')"
                        >
                            Κλείσιμο
                        </b-button>

                        <b-button
                            v-if="$store.getters.userRole == 'ROLE_ADMIN'"
                            variant="primary"
                            size="sm"
                            class="float-right"
                            @click="update"
                        >
                            Αποθήκευση
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </div>
    </main>
</template>

<script>
import {HTTP} from "@/main";
import Message from '@/components/Message.vue';
import UserDetailsForm from "@/components/UserDetailsForm";

export default {
    name: "SearchUsersComponent",
    components: {
        UserDetailsForm,
        Message,
    },

    data() {
        return {
            jobOptions: [{value: null, text: "---Επιλέξτε---"}],
            educationOptions: [{value: null, text: "---Επιλέξτε---"}],
            meeOptions: [{value: null, text: "---Επιλέξτε---"}],
            isAdvanced: false,
            activeTab: "",
            message: "",
            msgVisible: false,
            msgClass: "",
            searchedEfsa: null,
            searchedJobId: null,
            searchedMeeId: null,
            searchedEducationId: null,
            searchedFirstName: null,
            searchedLastName: null,
            searchedVerified: false,
            searchedRegistered: false,
            searchedBirthdayTo: null,
            searchedBirthdayFrom: null,
            searchedAll: true,
            currentPage: 0,
            totalItems: 0,
            perPage: 10,
            fields: [
                {
                    key: 'efSa',
                    label: 'ΣΑ'
                },
                {
                    key: 'afm',
                    label: 'ΑΦΜ'
                },
                {
                    key: 'lastName',
                    label: 'Επίθετο'
                },
                {
                    key: 'firstName',
                    label: 'Όνομα'
                },
                {
                    key: 'fatherName',
                    label: 'Πατρώνυμο'
                },
                {
                    key: 'motherName',
                    label: 'Μητρώνυμο'
                },
                {
                    key: 'edit',
                    label: 'Επεξεργασία'
                }
            ],
            users: [],
            selectedEfedros: null,
        };
    },

    created() {
        if (this.$store.getters.userRole == "ROLE_USER") {
            this.$router.push("home");
        }
        this.getJobs();
        this.getMee();
        this.getUniversities();
    },
    computed: {
        isDisabled() {
            return this.$store.getters.userRole == "ROLE_MANAGER" || this.$store.getters.userRole == "ROLE_SXHMATISMOS"
        },
        efsaValidation() {
            // check if efsa contains exactly 11 digits
            return (/^\d+$/.test(this.searchedEfsa) && this.searchedEfsa.length === 11);
        },
        birthdayValidation() {
            if (this.searchedBirthdayTo !== '' && this.searchedBirthdayTo !== null && this.searchedBirthdayFrom !== '' && this.searchedBirthdayFrom !== null) {
                let fromDate = new Date(this.searchedBirthdayFrom);
                let toDate = new Date(this.searchedBirthdayTo);
                if (fromDate > toDate) {
                    return false;
                }
            }
            return true;
        },
        advancedSearchValidation() {
            console.log(this.dateValidation(this.searchedBirthdayTo))
            console.log(this.dateValidation(this.searchedBirthdayFrom))
            console.log(this.birthdayValidation)
            return (this.dateValidation(this.searchedBirthdayTo) != null ? this.dateValidation(this.searchedBirthdayTo) : true) &&
                (this.dateValidation(this.searchedBirthdayFrom) != null ? this.dateValidation(this.searchedBirthdayFrom) : true) &&
                this.birthdayValidation;
        }
    },
    methods: {
        dateValidation(str) {
            return (str === '' || str === null) ? null : (/^\d{4}$/.test(str));
        },
        pageChange(page) {
            this.currentPage = page;
            this.fetchData()
        },
        reset() {
            this.searchedEfsa = null;
            this.searchedJobId = null;
            this.searchedMeeId = null;
            this.searchedEducationId = null;
            this.searchedFirstName = null;
            this.searchedLastName = null;
            this.searchedVerified = false;
            this.searchedRegistered = false;
            this.searchedBirthdayTo = null;
            this.searchedBirthdayFrom = null;
            this.searchedAll = true;
        },
        fetchData() {
            let size = this.perPage == null ? 10 : this.perPage;
            let page = this.currentPage == null ? 0 : this.currentPage - 1

            let url = "/users/search?page=" + page + "&size=" + size + "";

            this.$store.dispatch('loading');

            let data = {};

            if (this.isAdvanced) {
                data = {
                    "jobId": this.searchedJobId,
                    "meeId": this.searchedMeeId,
                    "educationId": this.searchedEducationId,
                    "efsa": this.searchedEfsa,
                    "birthdayPeriodFrom": this.searchedBirthdayFrom,
                    "birthdayPeriodTo": this.searchedBirthdayTo,
                    "firstName": this.searchedFirstName !== "" ? this.searchedFirstName : null,
                    "lastName": this.searchedLastName !== "" ? this.searchedLastName : null,
                    "isRegistered": !this.searchedAll ? this.searchedRegistered : null,
                    "isVerified": !this.searchedAll && this.searchedRegistered ? this.searchedVerified : null,
                };
            } else {
                data = {
                    "efsa": this.searchedEfsa,
                };
            }


            HTTP.post(url, data).then(response => {
                this.users = response.data.responseData.content
                this.totalItems = response.data.responseData.totalElements
            }).catch((error) => {
                console.error(error);
                this.$bvToast.toast("Υπήρξε κάποιο πρόβλημα", {
                    title: `Αδύνατη αναζήτηση`,
                    variant: 'danger',
                    solid: true
                });
                this.users = []
                this.$store.dispatch('stop_loading');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
        edit: function (efsa) {
            this.getEfedros(efsa).then(() => {
                this.$bvModal.show('modal-1');
            })
        },
        exportChanges() {
            let size = 1000000;
            let page = 0;

            let url = "/users/search-download?page=" + page + "&size=" + size + "";

            let data = {}
            if (this.isAdvanced) {
                data = {
                    "jobId": this.searchedJobId,
                    "meeId": this.searchedMeeId,
                    "educationId": this.searchedEducationId,
                    "efsa": this.searchedEfsa,
                    "birthdayPeriodFrom": this.searchedBirthdayFrom,
                    "birthdayPeriodTo": this.searchedBirthdayTo,
                    "firstName": this.searchedFirstName !== "" ? this.searchedFirstName : null,
                    "lastName": this.searchedLastName !== "" ? this.searchedLastName : null,
                    "isRegistered": !this.searchedAll ? this.searchedRegistered : null,
                    "isVerified": !this.searchedAll && this.searchedRegistered ? this.searchedVerified : null,
                };
            } else {
                data = {
                    "efsa": this.searchedEfsa,
                };
            }

            this.$store.dispatch("loading")
            HTTP.post(url, data, {
                responseType: 'blob'
            }).then(res => {
                let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'efedros_verified_users.xls';
                link.click();
            }).catch((e) => {
                console.error(error);
                this.$bvToast.toast("Υπήρξε κάποιο πρόβλημα", {
                    title: `Αδύνατη αναζήτηση`,
                    variant: 'danger',
                    solid: true
                });
            }).finally(() => this.$store.dispatch("stop_loading"))
        },
        getEfedros: function (efsa) {
            this.$store.dispatch("loading");

            this.tableItems = []
            let url = "/users/" + efsa;

            return HTTP.get(url)
                .then(response => {
                    let simpleUser = response.data;

                    this.tableItems.push(simpleUser.efedros);
                    this.selectedEfedros = simpleUser;
                    if (this.selectedEfedros.afm == null) {
                        this.selectedEfedros.afm = Structs.Afm();
                    }
                    if (this.selectedEfedros.swmatometrika == null) {
                        this.selectedEfedros.swmatometrika == Structs.Swmatometrika();
                    }

                    this.$store.dispatch("stop_loading");
                })
                .catch(error => {
                    console.error(error);
                    this.$store.dispatch("stop_loading");
                });
        },
        update: function () {
            this.$refs.form.update()
        },
        success: function (event) {
            this.setMsg('success', event);
            this.search(this.searchedEfsa)
        },
        error: function (event) {
            this.setMsg('danger', event)
        },
        getJobs() {
            this.$store.dispatch('loading');
            let url = "/search/jobs";
            HTTP.get(url).then(response => {
                var resp = response.data;
                resp.jobs.sort((c1, c2) => (c1.epagLekt > c2.epagLekt) ? 1 : -1);
                for (const job of resp.jobs) {
                    this.jobOptions.push({value: job.epagKwd, text: job.epagLekt});
                }
                this.$store.dispatch('stop_loading');
            }).catch(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        getMee() {
            this.$store.dispatch("loading")
            HTTP.get("/admin/find-all-me")
                .then(response => {
                        let resp = response.data;
                        resp.responseData.sort((c1, c2) => (c1.monaLek > c2.monaLek) ? 1 : -1);
                        for (const x of resp.responseData) {
                            this.meeOptions.push({value: x.efEaPinakaE, text: x.monaLek});
                        }
                    }
                ).finally(() => this.$store.dispatch("stop_loading"))
        },
        getUniversities() {
            this.$store.dispatch('loading');
            let url = "/search/edu";
            HTTP.get(url).then(response => {
                var resp = response.data;
                resp.universities.sort((s1, s2) => (s1.sxolLekt > s2.sxolLekt) ? 1 : -1)
                for (const x of resp.universities) {
                    this.educationOptions.push({value: x.sxolKwd, text: x.sxolLekt});
                }
                this.$store.dispatch('stop_loading');
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            });
        },
    }
}
</script>

<style scoped>

</style>